import { ToolCall } from "src/actions/chatActions";

export interface AnalyticsContext {
  filters?: {
    selectedFilters?: any;
    filtersData?: any;
    filterValues?: any;
  };
  metrics?: {
    selectedMetrics?: any[];
    selectedAggregate?: any[];
    customColumns?: any[];
  };
  havingFilters?: {
    selectedHavingFilters?: any;
    havingFiltersData?: any;
    havingFilterValues?: any;
  };
  chartOptions?: {
    selectedChartType?: string;
    chartOptionsData?: any;
  };
  underlyingMetrics?: {
    selectedSummarizedMetrics?: any[];
    selectedUnderlyingMetrics?: any[];
  };
  reportMetadata?: {
    selectedReport?: any;
    selectedDataMartType?: string;
    selectedDbType?: string;
    dataMartType?: string;
    reportName?: string;
    reportDescription?: string;
    isAggregated?: boolean;
    metricType?: string;
    isAdminReport?: boolean;
  };
  config?: {
    selectedReportType?: string;
    selectedDashboardType?: string;
    currentSelectedNavTab?: string;
  };
  activeTab?: string;
  customMetrics?: any
}

export interface ReduxStateProps {
  filtersState?: any;
  aggregateState?: any;
  havingFiltersState?: any;
  chartOptionsState?: any;
  underlyingMetricsState?: any;
  reportMetaDataState?: any;
  configState?: any;
  analyticsContext?: AnalyticsContext;
  customMetricsState?: any
}

export interface AskAiDrawerProps extends ReduxStateProps {
  visible: boolean;
  onClose: () => void;
  context?: any;
  classes: any;
  t: any;
}

export enum AgentType {
  SUPPORT = 'support',
  BI = 'bi',
}

export interface SuggestionItem {
  title: string;
  subtitle: string;
  icon: string;
  query: string;
}

export interface AgentExecutionData {
  prompt: string;
  type: any;
  analyticsContext: AnalyticsContext;
  previous_conversation: string;
  metrics?: any;
  toolCalls?: ToolCall[];
}

// New types for real-time tool call rendering
export enum ToolCallStatus {
  PENDING = 'pending',
  RUNNING = 'running',
  COMPLETED = 'completed',
  FAILED = 'failed'
}

export interface RealTimeToolCall extends ToolCall {
  status: ToolCallStatus;
  startTime?: Date;
  endTime?: Date;
  error?: string;
  progress?: number;
  id?: string;
}

export interface ToolCallUpdate {
  id: string;
  status: ToolCallStatus;
  content?: any;
  error?: string;
  progress?: number;
} 